<template>
<phishing-reminder v-if="reminderDialog" :dialog="reminderDialog" @redirect="redirectToPhishing" @close="closeConfirmation" @neverAsk="neverAsk"/>

<div class="mt-5 pt-4">
	<nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Dashboard</strong></li>
					<li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">{{ this.managerFilter? 'Managed Users view' : 'All Users view' }}</li>
        </ol>
      </nav>
</div>

<div>
    <!-- Toggle Drag Mode -->
		<div class="mt-5 mb-2 d-flex justify-content-end">
			<!-- filter -->
			<div v-if="$store.state.auth.isManager && !this.$store.state.auth.isGeneralUser" class="d-flex flex-row align-items-center">
					<button @click="toggleManagerView()" style="background-color: transparent; color: #00a0c1; border: none; padding: 5px 10px; border-radius: 5px; font-size: x-small;" v-tooltip.top="managerFilter ? 'Show All Users': 'Show Managed Users'" >
					<i :class="managerFilter ? 'fas fa-user-cog fa-2x' : 'fas fa-users fa-2x'"></i>
				</button>
			</div>

			<div class="toggle-button d-none d-md-block d-sm-block d-sm-none">
				<button @click="toggleDragMode('save')" style="background-color: transparent; color: #00a0c1; border: none; padding: 5px 10px; border-radius: 5px;" v-tooltip.top="isDraggable ? 'Save Layout': 'Customise Layout'" >
					<i :class="isDraggable ? 'fas fa-save fa-2x' : 'fas fa-grip fa-2x'"></i>
				</button>

				<button v-show="isDraggable" @click="cancelChanges()" style="background-color: transparent; color: #eb1c24; border: none; padding: 5px 10px; border-radius: 5px;" v-tooltip.top="'Cancel Customisation'" >
					<i class="fas fa-window-close fa-2x"></i>
				</button>
			</div>
		</div>

    <!-- Vue Grid Layout (only when rearranging) -->
		<grid-layout
		v-if="isDraggable"
			:key="orgID"
			:layout="layout"
			:col-num="12"
			:row-height="30"
			:margin="[10, 10]"
			:is-draggable="isDraggable"
			:is-resizable="isDraggable"
			:vertical-compact="true"
			:use-css-transforms="true"
			:autoSize="true"
			:breakpoints="{ lg: 1200, md: 997, sm: 768, xs: 480, xxs: 0 }"
		>
			<grid-item
				v-for="(item,index) in layout"
				:key="item.i"
				:x="item.x"
				:y="item.y"
				:w="item.w"
				:h="item.h"
				:i="item.i"
				:min-w="3"
				:min-h="getMinHeight(item)"
				:is-resizable="true"
				:static="item.static"
				v-show="item.showProduct"
			>
			<div v-if="item.showProduct">
				<!-- Checkbox to toggle visibility -->
				<div class="widget-box">
								<!-- Enclosing the component with the visibility control -->
					<div class="widget-content mb-3">
						<div class="widget-container">
							<div class="placeholder-widget">
								<h5 class="text-muted">{{ item.component }}</h5>
							</div>
						</div>
					</div>

					<div class="widget-footer">
						<div class="styled-checkbox" style="display: inline-block;">
								<input
										class="form-check-input"
										type="checkbox"
										:id="'checkbox' + index"
										v-model="item.visible"
										:disabled="!item.showProduct"
								/>
								<label class="form-check-label" :for="'checkbox' + index" style="cursor: pointer;" v-tooltip.top="item.visible ? 'Hide Widget': 'Show Widget'" ></label>
						</div>
					</div>
				</div>
			</div>
			</grid-item>
		</grid-layout>


		<div v-else>
			<div class="row" v-if="!loading">
				<div
					v-for="item in sortedLayout"
					:key="item.i"
					:class="getBootstrapClass(item)"
					class="mt-5"
					v-show="item.visible && item.showProduct"
				>
					<component
						:is="item.component"
						:organisationID="orgID"
						:key="dashboardKey"
						:showProduct="item.visible && item.showProduct"
						:isManager="managerFilter"
					/>
				</div>
			</div>
		</div>

    <!-- Bootstrap Grid Layout (after saving) -->
</div>
</template>


<script>
	import { VueScreenSizeMixin } from 'vue-screen-size';
	import Overdue from '@/components/dashboard/Overdue.vue';
	import ClickThrough from '@/components/dashboard/ClickThrough.vue';
	import PieSummary from '@/components/dashboard/PieSummary.vue';
	import Ecc from '@/components/dashboard/EmailCompromiseCheck.vue';
	import PentestSummary from '@/components/dashboard/PentestSummary.vue';
	import PhishingReminder from '@/components/PhishingReminder.vue';
	// import AcceptanceStatus from '@/components/policies/PolicyAcceptanceStatus.vue';
	import AcceptanceReport from '@/components/policies/PolicyAcceptanceReport.vue';


  export default {
    name: 'Dashboard',
		mixins: [VueScreenSizeMixin],

		components: {
			PieSummary,
			PentestSummary,
			Overdue,
			Ecc,
			PhishingReminder,
			ClickThrough,
			// AcceptanceStatus,
			AcceptanceReport
		},

		data(){
			return {
				loading: true,
				dashboardKey: 0,
				hasECC: false,
				hasTraining: false,
				hasPentest: false,
				hasPhishing: false,
				hasPolicy: false,
				vssWidth: 3000,
				reminderDialog: false,
				campaigns: [],
				managerFilter: this.$store.state.auth.isManager ? true : false,

				//grid layout
				layout: [],
				savedLayout: [],
				defaultLayout: [
					{ x: 0, y: 0, w: 3, h: 9.8, i: "0", static: false, component: 'PieSummary', condition: "hasTraining", showProduct: true, visible:true },
					{ x: 3, y: 0, w: 5, h: 13, i: "1", static: false, component: 'Overdue', condition: "hasTraining", showProduct: true, visible:true },
					{ x: 8, y: 0, w: 4, h: 16, i: "2", static: false, component: 'ClickThrough', condition: "hasPhishing", showProduct: true, visible:true  },
					{ x: 0, y: 1, w: 4, h: 10, i: "3", static: false, component: 'Ecc', condition: "hasECC", showProduct: true, visible:true },
					{ x: 4, y: 1, w: 8, h: 18, i: "4", static: false, component: 'AcceptanceReport', condition: "hasPolicy", showProduct: true, visible:true  },
					{ x: 0, y: 3, w: 12, h: 20, i: "6", static: false, component: 'PentestSummary', condition: "hasPentest", showProduct: true, visible:true  },
				],
			isDraggable: false,
			}
		},

		async mounted() {
			await this.init();
			this.vssWidth = this.$vssWidth;

			await this.getUserSettings()
			this.loading = false;

			if (!this.$store.state.auth.isSuperAdmin)
				this.setPhishingReminder()
		},

		methods: {
			getUserSettings() {
				return this.$axios.get('/user-settings/users/' + this.$store.state.auth.jwtPayload.user_id)
					.then((response) => {
						if (response.data.success) {
							if (!response.data.settings || !response.data.settings.grid_layout) {
								this.layout = this.updateConditions(this.defaultLayout);
								this.createUserPreference();
							} else {
								try {
									let gridLayout = JSON.parse(response.data.settings.grid_layout);


									// Check if any changes exist before updating
									if (!this.hasLayoutChanged(gridLayout, this.defaultLayout)) {
										this.layout = gridLayout;
										this.layout = this.updateConditions(gridLayout);
										this.savedLayout = this.deepClone(this.layout);
									} else {
										this.layout = this.updateConditions(this.syncLayout(gridLayout, this.defaultLayout));
										this.savedLayout = this.deepClone(this.layout);
									}
								} catch (error) {
									console.error('Error parsing grid layout:', error);
									this.layout = this.updateConditions(this.defaultLayout);
									this.savedLayout = this.deepClone(this.layout);
								}
							}
						} else {
							this.layout = this.updateConditions(this.defaultLayout);
							this.savedLayout = this.deepClone(this.layout);
						}
					})
					.catch((error) => {
						console.error('Error fetching user settings:', error);
						this.layout = this.updateConditions(this.defaultLayout);
						this.savedLayout = this.deepClone(this.layout);
					});
			},

			getMinHeight(item) {
				const minHeights = {
					PieSummary: 9.8,
					Overdue: 13,
					ClickThrough: 16,
					Ecc: 10,
					AcceptanceReport: 18,
					PentestSummary: 30,
				};
				return minHeights[item.component] || 4; // Default min height
			},

			hasLayoutChanged(savedLayout, defaultLayout) {
				if (savedLayout.length !== defaultLayout.length) return true;

				return defaultLayout.some((defaultItem) => {
					const savedItem = savedLayout.find((item) => item.i === defaultItem.i);

					if (!savedItem) return true;

					return (
						savedItem.h !== defaultItem.h ||
						savedItem.condition !== defaultItem.condition
					);
				});
			},

			syncLayout(savedLayout, defaultLayout) {
				return defaultLayout.map(defaultItem => {
					let savedItem = savedLayout.find(item => item.i === defaultItem.i);
					return savedItem
						? { ...savedItem, h: defaultItem.h, condition: defaultItem.condition }
						: defaultItem;
				});
			},

			async createUserPreference() {

				let data = {
					user_id: this.$store.state.auth.jwtPayload.user_id,
					grid_layout: this.updateConditions(this.defaultLayout),
				}

				await this.$axios.post("/user-settings/users/" + this.$store.state.auth.jwtPayload.user_id, data)
					.then((response) => {
						if (!response.data.success)
							this.$toast.error("Failed creating user settings.")
					})
					.catch()
			},

			itemTitle(item) {
				let result = item.i;
					if (item.static) {
						result += " - Static";
					}
					return result;
			},

			async toggleDragMode(state) {
				this.isDraggable = !this.isDraggable;

				if (this.isDraggable == false && state == "save") {
					this.updateUserSettings(true)
					this.savedLayout = this.deepClone(this.layout);  // Use this.deepClone here
				}
			},

			deepClone(obj) {
					if (obj === null || typeof obj !== 'object') return obj;

					// Handle Date
					if (obj instanceof Date) {
						return new Date(obj.getTime());
					}

					// Handle Array
					if (Array.isArray(obj)) {
						let arrCopy = [];
						for (let i = 0; i < obj.length; i++) {
							arrCopy[i] = this.deepClone(obj[i]);  // Call deepClone recursively with `this`
						}
						return arrCopy;
					}

					// Handle other objects
					let objCopy = {};
					for (let key in obj) {
						// Use Object.prototype.hasOwnProperty.call() instead
						if (Object.prototype.hasOwnProperty.call(obj, key)) {
							objCopy[key] = this.deepClone(obj[key]);  // Call deepClone recursively with `this`
						}
					}
					return objCopy;
				},



			cancelChanges() {
				this.loading = true;
				this.isDraggable = false;

				// Deep copy using your custom deepClone method
				this.layout = this.deepClone(this.savedLayout);  // Use this.deepClone here

				setTimeout(() => {
					this.loading = false;
				}, 300);
			},

			updateUserSettings(toNotify) {
				const updatedLayout = JSON.stringify(this.layout);

				const data = {
					user_id: this.$store.state.auth.jwtPayload.user_id,
					grid_layout: updatedLayout
				};

				return this.$axios.put('/user-settings/users/' + this.$store.state.auth.jwtPayload.user_id, data)
					.then((response) => {
						if (response.data.success) {
							if (toNotify)
								this.$toast.success("User settings updated successfully.")
						} else {
							if (toNotify)
								this.$toast.error("Failed to update user settings.")
						}
					})
					.catch((error) => {
						console.error('Error updating user settings:', error);
					});
			},

			getBootstrapClass(item) {
					const colSize = Math.floor((item.w / 12) * 12); // Convert grid width to Bootstrap col-12

					if (window.innerWidth < 1650) {
							return `
									col-12
									col-sm-${Math.min(colSize * 2, 12)}
									col-md-${Math.min(colSize * 2, 12)}
									col-lg-6
							`.trim();
					}

					return `
							col-12
							col-sm-${Math.min(colSize * 2, 12)}
							col-md-${Math.min(colSize, 6)}
							col-lg-${colSize}
					`.trim();
			},


			updateConditions(layout) {
				return layout.map(item => ({
					...item,
					showProduct: this.evaluateCondition(item.condition)
				}));
			},

			evaluateCondition(condition) {
				switch (condition) {
					case "hasTraining":
						return this.hasTraining;
					case "hasPhishing":
						return this.hasPhishing;
					case "hasECC":
						return this.hasECC;
					case "hasPentest":
						return this.hasPentest;
					case "hasPolicy":
						return this.hasPolicy;
					default:
						return false;
				}
			},

			init(){
				if (this.$store.state.auth.isSuperAdmin || this.$store.state.user.is_organisation_admin || this.$helper.isVertexAnalyst()){
					// this.loading = false;
					this.hasTraining = true;
					this.hasECC = true;
					this.hasPentest = true;
					this.hasPhishing = true;
					this.hasPolicy = true;
					return;
				}

				if (this.$store.state.auth.isPentester){
					this.hasPentest = true;
				}

				if (this.$store.state.auth.isManager && this.managerFilter == true) {
					this.filterProducts()
					return;
				}

				this.setProductAccess()

			},

			filterProducts(){
				let products = this.$store.state.auth.orgProducts

				for (const product of products) {
					const productName = product.product.toLowerCase();

					if (productName === "email compromise check") {
						this.hasECC = true;
					}

					if (productName === "cyber security online awareness training") {
						this.hasTraining = true;
					}

					if (productName === "automated test phishing campaigns") {
						this.hasPhishing = true;
					}

					if (productName === "policy management") {
						this.hasPolicy = true;
					}
				}
			},

			setProductAccess(){
				this.hasECC = this.$store.state.auth.isECCAdmin;
				this.hasTraining = this.$store.state.auth.isTrainingAdmin;
				this.hasPentest = this.$store.state.auth.isPentestAdmin || this.$store.state.auth.isPentester;
				this.hasPhishing = this.$store.state.auth.isPhishingAdmin;
				this.hasPolicy = this.$store.state.auth.isPolicyAdmin;
			},

			resetProductAccess() {
				this.hasTraining = false;
				this.hasECC = false;
				this.hasPhishing = false;
				this.hasPentest = false;
				this.hasPolicy = false;
			},

			async getAutoCampaign() {
				if (this.$helper.isVertexAnalyst() || (!this.$store.state.auth.isPhishingAdmin) || !this.hasPhishing) {
					return
				}

				await this.$axios.get('/orgadmin/organisations/'+  this.orgID +'/organisation-campaign')
				.then((response) => {
						if (response.data.success){
							this.campaigns = response.data.campaigns
						} else {
							this.campaigns = []
						}
				})
				.catch()
			},

			async setPhishingReminder() {

				if (this.$helper.isVertexAnalyst()) {
					// Retrieve the JSON string from local storage
					const organisationString = localStorage.getItem('userOrganisation');

					// Convert the JSON string back to an object
					let analystOrg = JSON.parse(organisationString);

					if (this.orgID !=  analystOrg.id) {
						return
					}
				}

				await this.getAutoCampaign();

				if (this.campaigns.length != 0 && this.campaigns[0].is_active == 1) return

				// Check local storage if reminder is created, if not create
				if (localStorage.getItem('phishing_reminder') === null) {
					localStorage.setItem('phishing_reminder', 'empty');
				}

				var reminderValue = localStorage.getItem('phishing_reminder');

				if (reminderValue == false || reminderValue === 'false') return;


				// The original ternary operator was buggy for analysts viewing orgs with multiple products.
				// This now correctly gets all products for the viewed organisation.
				let products = this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.products.product : this.$store.state.user.organisation.products;
				var hasPhishing = false;

				if (Array.isArray(products)) {
					for (const product of products) {
						if (product.product.toLowerCase() == "automated_test_phishing_campaigns") {
							if (this.$store.state.user.is_organisation_admin) {
								hasPhishing = true;
								break;
							} else if (product.roles.includes("admin")) {
								hasPhishing = true;
								break;
							}
						}
					}
				}

				if (!hasPhishing) return

				//if zero value meaning just created
				if (reminderValue === 'empty') {
					const orgFeatures = await this.getOrganisationFeatures();
					if (orgFeatures != null && orgFeatures.length > 0) {

						const reminder = orgFeatures[0].phishing_reminder
						switch (reminder) {
							case null:
								this.updateOrganisationFeature(true);
								localStorage.setItem('phishing_reminder', true);
								reminderValue = true;
								break;
							case true:
								reminderValue = true;
								localStorage.setItem('phishing_reminder', true);
								break;

								case false:
								reminderValue = false;
								localStorage.setItem('phishing_reminder', false);
								break;
						}
					}
				}

				if (reminderValue == true || reminderValue === 'true')
					this.reminderDialog = true;
			},

			async getOrganisationFeatures() {
				let data = await this.$axios.get(`/orgadmin/organisations/`+ this.orgID +`/organisation-feature`)
					.then((response) => {
							if (response.data.success){
								return response.data.org_features
							} else {
								this.$toast.error(response.data.message)
								return null
							}
					})
					.catch()

				return data
			},

			async updateOrganisationFeature(value){
				let data = {
					organisation_id: this.orgID,
					phishing_reminder: value,
				}
				const orgFeature = await this.$axios.put("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
				return orgFeature
			},

			redirectToPhishing(){
				this.$router.push({ name: 'PhishingCampaignSettings' })
				localStorage.setItem('phishing_reminder', false)
			},

			closeConfirmation(){
				localStorage.setItem('phishing_reminder', false)
				this.reminderDialog = false;
			},

			neverAsk() {
				this.updateOrganisationFeature(false);
				localStorage.setItem('phishing_reminder', false)
			},

			resetData(){
				this.loading = false
			},

			async toggleManagerView() {
				if (this.$store.state.auth.isGeneralUser) {
					return
				}

				//set manager filter
        this.managerFilter = !this.managerFilter

				await this.resetProductAccess()
				await this.init()

				this.layout = this.updateConditions(this.layout);


				//reset dashboard key
				this.dashboardKey++
      },

		},

		watch: {
			organisation(){
				if (this.$store.state.auth.accessToken == null) return
				this.loading = true
				//reset data
				this.resetData()
				this.dashboardKey += 1
			},
		},

		computed: {
			organisation(){
					return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation;
			},

			sortedLayout() {
				return [...this.layout].sort((a, b) => {
					if (a.y === b.y) return a.x - b.x; // Sort by x if y is the same
					return a.y - b.y; // Sort by y first
				});
			},
			orgID() {
				if (this.$helper.isVertexAnalyst()) {
					return this.$store.state.user.organisation.id;
				}
				return this.$helper.setOrganisationID();
			},
		},
	}

</script>


<!-- change color to hex a3c0d1 -->


<style scoped >
.grid-item {
  display: flex;
  flex-direction: column;
}

.widget-box {
  position: relative;
  border: 1px solid #ccc;
  padding: 0px;
  border-radius: 8px;
  background-color: white;
}

.widget-footer {
	margin-top: 10px;
	margin-bottom: 10px;
  position: absolute;
	bottom: 0px;
	right: 10px;
	z-index: 10;
}

.widget-content {
  padding-bottom: 30px;
  padding-top: 10px;
}

.styled-checkbox {
    position: relative;
    width: 25px;
    height: 25px;
  }

  .styled-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .styled-checkbox label {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    background-color: transparent;
    border: 2px solid #6c757d;
    border-radius: 1px;
  }

  .styled-checkbox input:checked + label {
    border-color: #198754;
  }

  .styled-checkbox input:checked + label::before {
    content: '\2713'; /* Unicode checkmark character */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #198754;
    font-weight: bold;
  }

	.widget-container {
		position: relative; /* To position the blocking overlay correctly */
	}

	.block-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0); /* Transparent background */
		z-index: 10; /* Ensure it's on top of the widget content */
		pointer-events: auto; /* Block all pointer events */
	}

	:deep(.vue-grid-item.vue-grid-placeholder) {
    background: #00a0c1 !important;
	}

	:deep(.vue-grid-item:not(.vue-grid-placeholder)) {
			background: #ccc;
			border: 1px solid white;
			border-radius: 10px;
	}

	:deep(.vue-grid-item > .vue-resizable-handle) {
			position: absolute;
			width: 40px; /* Increase width */
			height: 40px; /* Increase height */
			bottom: 0;
			right: 0;
			background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=);
			background-position: bottom right;
			padding: 0 6px 6px 0; /* Adjust padding for better placement */
			background-repeat: no-repeat;
			background-origin: content-box;
			box-sizing: border-box;
			cursor: se-resize;
			z-index: 9999 !important;
	}

	:deep(.vue-grid-item) {
			touch-action: none;
	}

	button {
    transition: all 0.3s ease-in-out;
	}

	button:hover {
			transform: scale(1.1); /* Slightly enlarges the button */
			box-shadow: 0px 4px 8px rgba(0, 160, 193, 0.4); /* Adds a glowing effect */
	}

	.placeholder-widget {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		min-height: 150px; /* Ensure placeholder has a minimum height */
		width: 100%;
		background-color: #f8f9fa;
		border: 2px dashed #dee2e6;
		border-radius: 8px;
		text-align: center;
	}
</style>